
import { defineComponent } from "vue";

export default defineComponent({
  name: "LInput",
  props: {
    pholder: { type: String, default: "" },
    id: { type: String },
    name: { type: String },
    value: { type: String, default: "" },
    input: { type: String, default: "" },
  },

  computed: {
    setModel: {
      get() {
        return this.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(val: any) {
        this.$emit("update:input", val);
      },
    },
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    focus(event: any) {
      event.target.parentNode.classList.add("focus-inputs");
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    focusRemove(event: any) {
      event.target.parentNode.classList.remove("focus-inputs");
    },
  },
});
